export default function prepareObjectToFormUpdate (object) {
  for (let key in object) {
    if (object[key] instanceof Object) {
      if (object[key]['@id']) {
        object[key] = object[key]['@id']
      }
    }
  }
  return object
}
